<template>
  <div class="supplier-management">
    <h3>请输入查询条件</h3>
    <div style="display: flex;justify-content: space-between;align-items: flex-start;">
      <div>
        <el-form :inline="true" :model="queryParams" class="demo-form-inline">
          <el-form-item label="供应商名称：">
            <el-input
              placeholder="请输入搜索内容"
              v-model="queryParams.supplierName"
              clearable
              style="border-top-left-radius: 0;border-bottom-left-radius: 0;width: 300px;"
            >
              <i
                slot="suffix"
                class="el-icon-search"
                @click="search"
                style="font-size: 18px;line-height: 40px;margin-right: 10px;color: black;cursor: pointer;"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-button type="info" @click="drawer = true">批量管理</el-button>
      </div>
    </div>
    <el-row :gutter="20">
      <el-col :span="6"
        ><div
          class="grid-content bg-purple"
          style="display: flex;align-items: center;justify-content: center;box-sizing: border-box;"
        >
          <div
            style="display: flex;flex-direction: column;align-items: center; cursor:pointer"
            @click="addSupplier"
          >
            <div style="font-size: 20px;margin-bottom: 20px;">
              <i class="el-icon-plus" style="color: #96969c;"></i>
            </div>
            <div style="font-size: 16px;color: #96969c">点击新增供应商</div>
          </div>
        </div></el-col
      >
      <el-col :span="6" v-for="(item, index) in companyList" :key="index">
        <div
          :class="['grid-content', 'bg-purple', getClass(index)]"
          style="padding: 12px;display: flex;flex-direction: column;justify-content: space-between;box-sizing: border-box;"
          @click="checkSupplier(index)"
        >
          <div
            style="display: flex;justify-content: space-between;align-items: center;margin-bottom: 20px;"
          >
            <div style="display: flex;align-items: center;">
              <div style="margin-right: 10px; display: flex;align-items: center;">
                <img src="../../assets/imgs/company.svg" style="width: 25px;">
              </div>
              <div>
                <span style="font-size: 18px;font-weight: 700;">{{ item.supplierName }}</span>
              </div>
            </div>
            <div>
              <el-popover
                :append-to-body="false"
                @hide="hidePopover"
                @show="showPopover"
                placement="bottom"
                trigger="click">
                <div style="display: flex; flex-direction: column;">
                  <el-button type="text" @click="del(item.id)" style="color: black;">删除</el-button>
                </div>
                <i class="el-icon-more" style="font-size: 20px;" slot="reference"></i>
              </el-popover>
                
            </div>
          </div>
          <div style="display: flex;align-items: center;">
            <div style="display: flex;align-items: center;margin-right: 20px;font-size: 12px">
              <img src="../../assets/imgs/communication.svg" style="width: 12px;margin-right: 5px;">
              <span>{{ `通讯  ${item.supplierTel}` }}</span>
            </div>
            <div style="display: flex;align-items: center;font-size: 12px;">
              <img src="../../assets/imgs/number.svg" style="width: 12px;margin-right: 5px;">
              <span>{{ `编号  ${item.supplierCode}` }}</span>
            </div>
          </div>
          <div>
            <div style="display: flex;align-items: center;font-size: 12px;">
              <img src="../../assets/imgs/address.svg" style="width: 12px;margin-right: 5px;">
              <span>{{ `地址  ${item.supplierAddress}` }}</span>
            </div>
          </div>
          <div style="text-align: right;">
            <el-button type="primary" @click="edit(item)">编辑</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="block" align="right" style="margin-top: 30px;">
      <el-pagination
        layout="prev,jumper,slot, next"
        :total="total"
        :page-size="queryParams.pageSize"
        @current-change="handleCurrentChange"
      >
        <span style="display: inline;">/ </span>
        <span style="display: inline;">{{ pages }}</span>
      </el-pagination>
    </div>
    <el-dialog
      :visible.sync="isShowDialog"
      width="600px"
      append-to-body
      :show-close="true"
      @close="closeDialog"
    >
      <div slot="title">
        <div class="el-dialog-header-box">
          <div class="dialog-title-block"></div>
          <span class="dialog-title-text">添加供应商</span>
        </div>
      </div>
      <el-form
        :model="querySupplierForm"
        status-icon
        :rules="rules"
        ref="querySupplierForm"
        label-width="100px"
        style="display: flex;flex-direction: column;justify-content: space-between;"
      >
        <el-form-item label="供应商名称:" prop="supplierName">
          <el-input
            v-model="querySupplierForm.supplierName"
            autocomplete="off"
            placeholder="请输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="编号:" prop="supplierCode">
          <el-input
            v-model="querySupplierForm.supplierCode"
            autocomplete="off"
            placeholder="请输入编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系方式:" prop="supplierTel">
          <el-input
            v-model="querySupplierForm.supplierTel"
            placeholder="请输入联系方式"
          ></el-input>
        </el-form-item>
        <el-form-item label="地址:" prop="supplierAddress">
          <el-input
            v-model.number="querySupplierForm.supplierAddress"
            placeholder="请输入地址"
          ></el-input>
        </el-form-item>
        <el-form-item class="submit" style="margin-left: 200px">
          <el-button type="primary" @click="submitForm('querySupplierForm')" style="width: 120px;"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-drawer :visible.sync="drawer" direction="btt" :withHeader="false" :size="80">
      <div style="display: flex;height: 100%;align-items: center;justify-content: space-between; padding: 0 40px 0 15px;">
        <div>
          <el-button type="primary" @click="checkAll" style="width: 120px;">全选</el-button>
        </div>
        <div>
          <el-button type="danger" @click="batchDelete" style="width: 120px;" icon="el-icon-delete">批量删除</el-button>
          <el-button @click="drawer = false" style="width: 120px;">完成</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  data() {
        var validatePhone = (rule, value, callback) => {
        if (value) {
        	  var isPhone = /^1[3456789]\d{9}$/;
            var isMob=/^((0\d{2,3})-)?(\d{7,8})$/;
            if(isMob.test(value)||isPhone.test(value)){
              callback();
            }
            else{
              callback(new Error('电话号码格式错误！'));
            }
        } 
        };
    return {
      editStyle: false,
      pages: 1,
      check: [],
      drawer: false,
      isShowDialog: false,
      companyList: [],
      total: 10,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        supplierName: '',
      },
      querySupplierForm: {
        supplierName: '',
        supplierCode: '',
        supplierTel: '',
        supplierAddress: '',
      },
      rules: {
        supplierName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        supplierTel:[{ validator: validatePhone, trigger: 'blur' }]
      },
      delList: [],
      delOne: [],
    }
  },
  created() {
    this.getList()
  },
  mounted() {
    document.getElementsByClassName('el-pagination__jump')[0].childNodes[0].nodeValue = ''
  },
  methods: {
    batchDelete() {
      this.delList = []
      this.check.forEach((item, index) => {
        if (item) {
          this.delList.push(this.companyList[index].id)
        }
      })
      if(this.delList.length>0){
      this.$confirm('此操作将永久删除选中的供应商, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$api.post('/datacenter/deleteSupplierByIds', this.delList, (res) => {
            if (res.data.code === 200) {
              this.$message({
              type: 'success',
              message: '删除成功!',
              })
              this.getList()
              this.drawer = false
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!',
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
          this.drawer = false
        })
      }else{
        this.$message({
                type: 'error',
                message: '请先选择供应商!',
              })
      }

    },
    checkAll() {
      if (this.check.includes(false)) {
        this.check = this.companyList.map(() => true)
        this.companyList.forEach((item, index) => {
          document.getElementsByClassName(this.getClass(index))[0].style.border = '2px solid #ff904b'
        })
      } else {
        this.check = this.companyList.map(() => false)
        this.companyList.forEach((item, index) => {
          document.getElementsByClassName(this.getClass(index))[0].style.border = '1px solid #ebeef5'
        })
      }
    },
    showPopover() {
      event.stopPropagation()
    },
    hidePopover() {
      event.stopPropagation()
    },
    del(id) {
      this.$confirm('此操作将永久删除该供应商, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.delOne = [id]
          this.$api.post('/datacenter/deleteSupplierByIds', this.delOne, (res) => {
          if (res.data.code === 200) {
            this.$message({
            type: 'success',
            message: '删除成功!',
          })
          this.getList()
          } else {
            this.$message({
              type: 'error',
              message: '删除失败!',
            })
          }
        })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    addSupplier() {
      this.editStyle = false
      this.querySupplierForm = {
        supplierName: '',
        supplierCode: '',
        supplierTel: '',
        supplierAddress: '',
      }
      this.isShowDialog = true
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val
      this.getList()
    },
    edit(item) {
      event.stopPropagation()
      this.editStyle = true
      this.isShowDialog = true
      this.querySupplierForm = Object.assign({}, item)
    },
    checkSupplier(index) {
      if (this.check[index]) {
        this.check[index] = false
        document.getElementsByClassName(this.getClass(index))[0].style.border = '1px solid #ebeef5'
      } else {
        this.check[index] = true
        document.getElementsByClassName(this.getClass(index))[0].style.border = '2px solid #ff904b'
      }
    },
    getClass(index) {
      return 'supplier-' + index
    },
    closeDialog() {
      this.$refs.querySupplierForm.clearValidate()
    },
    submitForm(formName) {
      if (this.editStyle) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$api.post('/datacenter/updateSupplierInfoById', this.querySupplierForm, (res) => {
              if (res.data.code === 200) {
                this.$message({
                  message: '修改成功',
                  type: 'success',
                })
                this.isShowDialog = false
                this.getList()
              } else {
                this.$message({
                  message: '修改失败',
                  type: 'error',
                })
                this.isShowDialog = false
              }
            })
          } else {
            return false
          }
        })   
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$api.post('/datacenter/insertSupplierInfo', this.querySupplierForm, (res) => {
              if (res.data.code === 200) {
                this.$message({
                  message: '添加成功',
                  type: 'success',
                })
                this.isShowDialog = false
                this.getList()
              } else {
                this.$message({
                  message: '添加失败',
                  type: 'error',
                })
                this.isShowDialog = false
              }
            })
          } else {
            return false
          }
        })
      }
      
    },
    search() {
      this.getList()
    },
    getList () {
      this.$api.post('/datacenter/getSupplierPage', this.queryParams, (res) => {
        if(res.data) {
          this.companyList = res.data.data.list
          this.total = res.data.data.total
          if (res.data.data.pages === 0) {
            this.pages = 1
          } else {
            this.pages = res.data.data.pages
          }
          this.check = res.data.data.list.map(() => false)
          res.data.data.list.forEach((item, index) => {
            document.getElementsByClassName(this.getClass(index))[0].style.border = '1px solid #ebeef5'
          })     
        }
      })
    },
  },
}
</script>
<style scoped>
::v-deep .el-pagination__jump {
  margin-left: 0 !important;
}
/* ::v-deep .el-input {
  width: 300px;
} */
.el-row {
  margin-bottom: 20px;
}
.el-col {
  border-radius: 4px;
  margin-bottom: 20px;
}
.bg-purple {
  border: 1px solid #dcdfe6;
}
.grid-content {
  border-radius: 4px;
  height: 200px;
}
.el-dialog-header-box {
  display: flex;
  flex-direction: row;
}
.dialog-title-block {
  background-color: #3399ff;
  width: 4px;
  height: 20px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
}
.dialog-title-text {
  display: flex;
  align-items: center;
  margin-left: 5px;
  font-weight: 700;
}
::v-deep .submit .el-form-item__content {
  margin: 0 !important;
  width: 200px;
}
::v-deep .el-popover {
  min-width: 80px!important;
}
</style>
